// extracted by mini-css-extract-plugin
export default {"section":"Overview_section__bmb5l","stage":"Overview_stage__-23Em","title":"Overview_title__6wESO","text":"Overview_text__f-1gE"};